/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {APP_SHARED} from '../app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, FormsModule],
  selector: 'adn-confirm-object-state-modal',
  template: `
    <form class="form-horizontal" (ngSubmit)="confirm()">
      <div class="modal-header dialogAddStuff">
        <button type="button" class="close" (click)="modalRef.hide()">&times;</button>
        <h4 class="modal-title">Confirm {{textData.title}}</h4>
      </div>
      <div class="modal-body">
        <p>Confirm the {{textData.title}} of your {{objectData.object}} by clicking on the button below.</p>
        <p *ngIf="objectData.warningMessage" class="alert alert-warning">{{objectData.warningMessage}}</p>
      </div>
      <div class="modal-footer">
        <a class="btn btn-link btn-xs" (click)="modalRef.hide()">
          {{'button.cancel' | ogTranslate}}
        </a>
        <button type="submit" class="btn btn-default">Confirm {{textData.title}}</button>
      </div>
    </form>
  `
})
export class ConfirmObjectStateModalComponent {
  @Input() textData: {title: string};
  @Input() objectData: {object: string; warningMessage?: string};
  @Output() confirmed = new EventEmitter<void>();

  constructor(public readonly modalRef: BsModalRef) {
  }

  confirm(): void {
    this.confirmed.emit();
    this.modalRef.hide();
  }
}
